/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-17 15:13:17
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-17 15:14:51
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkModule/Components/NoResult/index.tsx
 */
import React from 'react';

import { getI18nFromGeneral } from '@/src/tools/tools';
import styles from './style.module.less';

function NoResult() {
  return (
    <div className={styles.container}>
      {getI18nFromGeneral('general.linkModule.Components.NoResult.no_result')}
    </div>
  );
}

export default NoResult;
